<template lang="pug">
.dropdown-menu(v-if="displayPersonAreas")
  .dropdown-content.content
    .dropdown-item
      p.has-text-weight-bold {{ $t("personList.highlighting") }}
    hr.dropdown-divider
    .dropdown-item
      p(v-if="personsOnPage.length == 0") {{ $t("personList.noPersonMarked") }}
      p(v-else) {{ $t("personList.sortingNote") }}
      ol.is-numeric-bracket
        li(v-for="person in personsOnPage")
          span.has-text-primary {{ person.surface }}
          | : {{ person.name }}
</template>

<script>
const { mapMutations, mapState } = require("vuex");
const { messages } = require("../i18n/person.js");
const personData = require("../../json/person.json");
const { Person } = require("../person");

export default {
    name: "PersonList",

    data() {
        return {
            personSpans: []
        };
    },

    i18n: { messages },

    computed: {
        personsOnPage() {
            const personsOnPage = [];
            this.personSpans.forEach((p, i) => {
                const personSplit = p.getAttribute("data-person").split(" #").filter(p => { return p != null });
                const persons = personSplit.map(pid => { return new Person(personData[pid].forename, personData[pid].surname) })
                personsOnPage.push({
                    id: p.getAttribute("data-person"),
                    index: i,
                    name: persons.join("; "),
                    surface: p.textContent
                });
            });
            return personsOnPage;
        },

        ... mapState("transcript", ["eventBus", "displayPersonAreas"])
    },

    methods: {
        close() {
            this.togglePersonAreasDisplay();
        },

        togglePersonAreaActive() {
            if(this.displayPersonAreas) {

                document.querySelectorAll("tspan.person")
                    .forEach(el => el.classList.add("active"));
            }
            else
            {
                document.querySelectorAll("tspan.person")
                    .forEach(el => el.classList.remove("active"));
            }
        },

        ...mapMutations("transcript", [ "togglePersonAreasDisplay" ])
    },

    watch: {
        displayPersonAreas() {
            this.togglePersonAreaActive();
        },
    },

    created() {
        this.eventBus.$on('svg-change', () => {
            this.$nextTick(() => {
                this.personSpans = Array.from(document.querySelectorAll(".surface tspan.person"));
                this.togglePersonAreaActive();
            })
        })
    },

    mounted() {
        this.$nextTick(() => {
            this.personSpans = Array.from(document.querySelectorAll(".surface tspan.person"));
        });
    }
}
</script>